/**
 * @generated SignedSource<<f847ffb4438c035002306667264d4bd1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PaperAssessmentStatus = "DONE" | "FAILED" | "QUEUED" | "RUNNING";
export type PaperFlagKind = "CLAIM_FAILS" | "INCREMENTAL" | "LOCAL_ERROR" | "MISSING_COMPARISON" | "OVERCLAIMS" | "POSSIBLE_ERROR" | "SMALL_NUMERICS_ONLY" | "STRONG_ASSUMPTIONS" | "UNCLEAR_NOVELTY" | "UNCLEAR_WRITING";
import { FragmentRefs } from "relay-runtime";
export type PaperAssessmentFragment$data = {
  readonly assessment: {
    readonly aiDisclosureQuote: string | null | undefined;
    readonly aiLikelihood: number | null | undefined;
    readonly aiUseDisclosed: boolean | null | undefined;
    readonly arxivVersion: number | null | undefined;
    readonly flags: ReadonlyArray<{
      readonly detail: string | null | undefined;
      readonly kind: PaperFlagKind;
    }>;
    readonly fullText: boolean | null | undefined;
    readonly model: string | null | undefined;
    readonly status: PaperAssessmentStatus;
    readonly summary: string | null | undefined;
  } | null | undefined;
  readonly assessmentRequestable: boolean;
  readonly id: string;
  readonly version: number | null | undefined;
  readonly " $fragmentType": "PaperAssessmentFragment";
};
export type PaperAssessmentFragment$key = {
  readonly " $data"?: PaperAssessmentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaperAssessmentFragment">;
};

import PaperAssessmentRefetchQuery_graphql from './PaperAssessmentRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": PaperAssessmentRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "PaperAssessmentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assessmentRequestable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PaperAssessment",
      "kind": "LinkedField",
      "name": "assessment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aiLikelihood",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aiUseDisclosed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aiDisclosureQuote",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "model",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "arxivVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PaperFlag",
          "kind": "LinkedField",
          "name": "flags",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "kind",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "detail",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Paper",
  "abstractKey": null
};

(node as any).hash = "b6cc31dd2dcfa189bf889ac1f556e8d0";

export default node;
